import { observable } from "mobx";
import {formatNullableValue, montarSelectOption, splitBR} from "../../../utils/formatar";
import {sortCaret} from "../../comum/components/Icones";
import {dadosInvalidos} from "../../../utils/mensagens";

export default class ControleAcessoStore {
    @observable novoCadastro;
    @observable termoAceito;

    @observable modalAdesao;
    @observable modalCadastro;
    @observable listaMensagens;

    @observable salvando;
    @observable salvo;
    @observable atualizaParceiros;
    @observable retornaHome;

    @observable paises;
    @observable ufs;
    @observable perfis;

    @observable paisSelecionado;
    @observable ufSelecionada;
    @observable alertaSemCadastro;

    @observable bloqueaRazao;
    @observable bloqueaEndereco;
    @observable bloqueaPais;
    @observable bloqueaEstado;
    @observable bloqueaCidade;
    @observable bloqueaCep;
    
    

    constructor(service) {
        this.termoAceito = false;

        this.modalAdesao = false;
        this.modalCadastro = false;
        this.listaMensagens = false;
        this.alertaSemCadastro = "";
        this.salvando = false;
        this.salvo = false;
        this.atualizaParceiros = true;
        this.retornaHome = false;

        this.paises = false;
        this.ufs = false;
        this.perfis = false;

        this.paisSelecionado = false;
        this.ufSelecionada = false;

        this.service = service;
        
        this.bloqueaRazao = false;
        this.bloqueaEndereco = false;
        this.bloqueaPais = false;
        this.bloqueaEstado = false;
        this.bloqueaCidade = false;
        this.bloqueaCep = false;

        this.novoCadastro = Object.assign({}, this.service.sample);
    };

    aceitarTermo = () => {
        this.termoAceito = true;
        this.modalAdesao = false;
        this.carregarDados();
    };

    carregarDados = () => {
        this.service.listarPais().then(response => {
            this.paises = montarSelectOption("CntryCode", "CntryName", response.data);
        });

        this.service.listarUF().then(response => {
            this.ufs=[];
            response.data.map(uf =>
                this.ufs.push({ value:uf.StateCode, label: uf.StateName, StateCntryCode: uf.StateCntryCode })
            );
        });

        //Não é para utilizar listar-perfil-usuario, mas sim listar-perfil
        this.service.listarPerfil().then(response => {
            this.perfis = [];
            response.data.map(perf => { perf.Id = parseInt(perf.Id); perf.marcado = false; this.perfis.push(perf) });
            this.perfis = [...this.perfis];
        });

        //Comentando para uso futuro em outra parte, se necessário

        // this.service.listarPerfilUsuario().then(response => {
        //     this.perfis = [];
        //     response.data.map(app => { app.marcado = false; this.perfis.push(app)});
        // });
    };

    changePais = (event) => {
        if (event) {
            this.paisSelecionado = event;
            this.novoCadastro.Empresa.Pais = event.value;
        } else {
            this.paisSelecionado = false;
            this.novoCadastro.Empresa.Pais = "";
        }
    };

    changeUF = (event) => {
        if (event) {
            this.ufSelecionada = event;
            this.novoCadastro.Empresa.Estado = event.value;
        } else {
            this.ufSelecionada = false;
            this.novoCadastro.Empresa.Estado = "";
        }
    };

    marcarPerfil = (ncm) => {
        ncm.marcado = !ncm.marcado;
        this.novoCadastro.Empresa.Perfis = this.perfis.filter(i => i.marcado===true).map(perf => perf.Id);
    };

    marcarTodosPerfis = (checked) => {
        this.perfis.map(item => item.marcado = checked);
        if (checked)
            this.novoCadastro.Empresa.Perfis = this.perfis.filter(i => i.marcado === true).map(perf => perf.Id);
        else
            this.novoCadastro.Empresa.Perfis = [];
    };

    adicionarParceiro = () => {
        this.novoCadastro.Empresa.Parceiros.push("");
    };

    removerParceiro = (x) => {
        this.atualizaParceiros = false;
        this.novoCadastro.Empresa.Parceiros.splice(x, 1);
        setTimeout(function () {
                this.atualizaParceiros = true;
        }.bind(this), 1);
    };

    salvar = () => {
        this.salvando = true;

        if (this.termoAceito) {
            if (this.invalido()) {
                if (!this.listaMensagens) this.listaMensagens = [dadosInvalidos];
                this.salvando = false;
            } else
                this.salvarUsuario();
        } else {
            this.listaMensagens = ["Aceite os termos de adesão"];
            this.salvando = false;
        }
    };

    invalido = () => {
        if (this.novoCadastro.Pessoa.Nome.length===0) return true;
        if (this.novoCadastro.Pessoa.Telefone.length===0) return true;
        if (this.novoCadastro.Empresa.Cnpj.length===0) return true;
        if (this.novoCadastro.Empresa.Nome.length===0) return true;
        if (this.novoCadastro.Empresa.Perfis.length===0) return true;        
        if (this.novoCadastro.Empresa.Parceiros.find(cnpj => cnpj.length < 14) !== undefined) return true;

        return false;
    };

    salvarUsuario = () => {
        this.service.salvarUsuario(this.novoCadastro).then(response => {
            if (response) {
                if (response.data.Sucesso) {
                    this.listaMensagens = ["Cadastro realizado com sucesso"];
                    this.retornaHome = true;
                } else {
                    this.listaMensagens = splitBR(response.data.Mensagem);
                }
            } else {
                this.listaMensagens = ["Não foi possível cadastrar usuário"];
            }
            this.salvando = false;
        })
    };

    verificaEmpresa = () => {
        if (this.novoCadastro.Empresa.Cnpj)
        {
            this.alertaSemCadastro = "";
            this.service.VerificarSeExisteCpfCnpj(this.novoCadastro.Empresa.Cnpj).then(response => {
                if (response) {
                    if (response.data.Sucesso) {
                        //Razao Social                        
                        if (response.data.Empresa.Razao)
                        {
                            this.novoCadastro.Empresa.Nome = response.data.Empresa.Razao;
                            this.bloqueaRazao = true;
                        }
                        //Endereco Comercial
                        if (response.data.Empresa.Endereco)
                        {
                            this.novoCadastro.Empresa.Endereco = response.data.Empresa.Endereco
                            this.bloqueaEndereco = true;
                        }
                        //País 
                        if (response.data.Empresa.PsCdPais)
                        {
                            this.bloqueaPais = true;
                            this.changePais({label: response.data.Empresa.DescPais, value: response.data.Empresa.PsCdPais})
                            //this.novoCadastro.Empresa.Pais = ;
                        }                        
                        //Estado
                        if (response.data.Empresa.Uf)
                        {
                            this.bloqueaEstado = true;
                            this.changeUF({label: response.data.Empresa.DescEstado, value: response.data.Empresa.Uf});
                        }      
                        //Cidade
                        if (response.data.Empresa.Cidade)
                        {
                            this.novoCadastro.Empresa.Cidade = response.data.Empresa.Cidade;
                            this.bloqueaCidade = true;
                        }      
                        //Cep
                        if (response.data.Empresa.Cep)
                        {
                            this.novoCadastro.Empresa.CEP = response.data.Empresa.Cep.toUpperCase();
                            this.bloqueaCep = true;
                        }    
                        //Telefone
                        //Email Empresa
                    } else {                        
                        this.bloqueaRazao = false;
                        this.bloqueaEndereco = false;
                        this.bloqueaPais = false;
                        this.bloqueaEstado = false;
                        this.bloqueaCidade = false;
                        this.bloqueaCep = false;         
                        this.novoCadastro.Empresa.Nome = "";
                        this.novoCadastro.Empresa.Endereco = "";
                        this.novoCadastro.Empresa.Cidade = "";
                        this.novoCadastro.Empresa.CEP = "";
                        this.changePais({label: "", value:""});
                        this.changeUF({label: "", value:""});
                        

                        this.alertaSemCadastro = response.data.MensagemErro;
                    }
                } else {
                    this.listaMensagens = ["Dados não encontrados"];
                }
            }).catch(err => console.error(err));
        }        
    }

    abrirCadastro = () => {
        this.modalCadastro = true;
    }

    fecharCadastro = () => {
        this.modalCadastro = false;        
    }
    
    mostrarMsgEnviar = () => {        

        this.listaMensagens = [`Prezado cliente, sua solicitação foi enviada para ${process.env.rig ? "atendimento.tcrg@wilsonsons.com.br" :
                               "atendimento.tcsv@wilsonsons.com.br"}. Retornaremos o mais breve possível.`];        
    }

    baixarTermoAdesao = () => {
        window.open(this.service.downloadTermo());
    };

    colunasPerfis = [{
        dataField: "Texto",
        text: "Perfis",
        sort: true,
        sortCaret: sortCaret,
        formatter: formatNullableValue,
        headerAlign: (column, colIndex) => 'left'
    }];
}



// WEBPACK FOOTER //
// ./src/modules/controleacesso/stores/ControleAcessoStore.js